import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import { ThemeProvider } from 'styled-components'

import { assignPrefix } from '../../constants'
import GlobalStyle from '../../utils/styles'
import theme from '../../utils/styles/theme'

const ThirdPartyScript = ({ code: __html }: { code: string }) => <script dangerouslySetInnerHTML={{ __html }} />

type BaseTemplateProps = { metaTitle?: string; title?: string; url?: string; children?: any }

const BaseTemplate: React.FunctionComponent<BaseTemplateProps> = ({ url, children, title, metaTitle }) => (
  <Fragment>
    <Helmet htmlAttributes={{ lang: 'en' }}>
      {<title>{metaTitle || title}</title>}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {url && <link rel="canonical" href={`${url}`} />}
      <meta name="apple-mobile-web-app-title" content="Prisma" />
      <meta name="application-name" content="Prisma" />
      <meta name="msapplication-TileColor" content="#0c344b" />
      <meta name="theme-color" content="#ffffff" />
      <link rel="apple-touch-icon" sizes="180x180" href={assignPrefix('/blog/apple-touch-icon.png')} />
      <link rel="icon" type="image/png" sizes="32x32" href={assignPrefix('/blog/favicon-32x32.png')} />
      <link rel="icon" type="image/png" sizes="16x16" href={assignPrefix('/blog/favicon-16x16.png')} />
      <link rel="manifest" href={assignPrefix('/blog/site.webmanifest')} />
      <link rel="mask-icon" href={assignPrefix('/blog/safari-pinned-tab.svg')} />
      <link rel="alternate" type="application/rss+xml" title="Prisma Blog" href="https://www.prisma.io/blog/rss.xml" />
      <script src="https://kit.fontawesome.com/0d6bc3c713.js" crossOrigin="anonymous"></script>
      <ThirdPartyScript code="<!-- Hotjar Tracking Code for https://www.prisma.io -->\n(function(h,o,t,j,a,r){ h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:980061,hjsv:6}; a=o.getElementsByTagName('head')[0]; r=o.createElement('script');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');" />
    </Helmet>
    <GlobalStyle />
    <>{children && <ThemeProvider theme={theme}>{children}</ThemeProvider>}</>
  </Fragment>
)
export default BaseTemplate
